export const isNullOrWhiteSpace = (input: string | null | undefined): boolean => {
	return !input || !input.trim();
};

export const isJsonStringArray = (input: string): boolean => {
	if (typeof input !== 'string') return false;
	try {
		const result = JSON.parse(input);
		const type = Object.prototype.toString.call(result);
		return type === '[object Array]';
	} catch (err) {
		return false;
	}
};

export const isLettersAndNumbersOnly = (input: string): boolean => {
	if (isNullOrWhiteSpace(input)) return true;
	return Boolean(input.match(/^[A-Za-z0-9 .']+$/));
};

// Insert soft hyphen characters into long runs of non-whitespace so browsers
// can break them with a hyphen when needed. `maxRun` is the maximum number
// of consecutive non-whitespace characters allowed before inserting a soft hyphen.
export const insertSoftHyphens = (input: string | null | undefined, maxRun = 20): string => {
	if (!input) return '';
	let run = 0;
	let out = '';
	for (let i = 0; i < input.length; i++) {
		const ch = input[i];
		out += ch;
		if (ch === ' ' || ch === '\t' || ch === '\n' || ch === '-' || ch === '\u00AD') {
			run = 0;
			continue;
		}
		run++;
		if (run >= maxRun) {
			out += '\u00AD';
			run = 0;
		}
	}
	return out;
};
